import { Component } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss']
})
export class ContactsComponent {
  title = 'eunomiaaudit';
}
